import { FC } from 'react';

export const SubjectListHeader: FC<{ totalElements: number }> = ({
  totalElements,
}) => {
  return (
    <h2 className='flex items-center text-[24px] font-semibold'>
      Subject List{' '}
      {!!totalElements && (
        <>
          <span className={'width-[6px] height-[6px] mx-0.5 text-pastelBlue'}>
            •
          </span>
          <span className='text-1824 font-medium'>{totalElements} </span>
          <span className='ml-0.5 text-1624 font-medium'>
            {totalElements === 1 ? 'Subject' : 'Subjects'}
          </span>
        </>
      )}
    </h2>
  );
};
